/**
 * created by lei lei on 2020/6/12
 * 图标类粉丝数
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import IconStatistic from'./IconStatistic'

export default class IconStatisticComponents extends Component {
    static defaultProps = {}
    static propTypes = {}

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        return (
            <div>
                <IconStatistic
                    iconType={'notFiled'}
                    title={'备案总体 50'}
                    numAll={30}
                    mark={'(未备案 20)'}
                    showMore={true}
                    onClickMore={()=>{
                        console.log('点击了更多')
                    }}
                    onClickFunction={()=>{
                        console.log('点击了某一项')
                    }}
                    customWidthHeight={70}
                />
                <IconStatistic
                    iconType={'weChat'}
                    title={'总计'}
                    numAll={30}
                    mark={'(10活跃)'}
                    onClickFunction={()=>{
                        console.log('点击了某一项')
                    }}
                />
            </div>
        )
    }

}